module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0051.jpg?v=8a040ed9";